import { toast } from "react-toastify";
import {
    deleteDataFromApi,
    getDataFromApi,
    postDataFromApi,
    putDataFromApi,
} from "../../../../../services/commonServices";
import { AMCUpdateApi, AMCCreateApi, AMCGetApi, AMCDeleteApi } from "../../../../../services/api";
import { getCurrentRole } from "../../../../../services/commonFunction";

export const handleGetAMC = async (EditRecordId, setFormData, status, setIsOverlayLoaders) => {
    try {
        setIsOverlayLoaders(true)
        let AMCGetApiById = AMCGetApi(EditRecordId)
        let res = await getDataFromApi(AMCGetApiById)
    
        if (res.data.status === 200) {
            
            setFormData((prevFormData) => {
                return {
                    0: {
                        ...prevFormData[0],
                        ...res?.data?.data,

                        fk_company:
                            status === "View"
                                ? res?.data?.data?.company_name 
                                : res?.data?.data?.fk_company,

                        fk_branch:
                            status === "View"
                                ? res?.data?.data?.branch_name
                                : res?.data?.data?.fk_purchase_branch,

                        fk_department:
                            status === "View"
                                ? res?.data?.data?.department_name 
                                : res?.data?.data?.fk_department,

                        // fk_itemmaster:
                        //     status === "View"
                        //         ? res?.data?.data?.item_rm_code 
                        //         : res?.data?.data?.fk_itemmaster,

                    },
                };
            });
        }
        else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    } catch (error) {
        // console.log('errrr',error)
    }
    finally {
        setIsOverlayLoaders(false)
    }
}

export const handleAMCCreateUpdate = async (
    formData,
    handleSubmit,
    setIsOverlayLoader,
    navigate,
    status,
    isCustomPopup,
    setIsCustomPopup,
    setFormData,
    section,
    isFromSubForm
    , callback
) => {
    try {
        setIsOverlayLoader(true)
        if (!isCustomPopup) {
            let isValidate = handleSubmit();
            if (!isValidate) {
                return false;
            }
        }
        let payloadData = {
            fk_company: formData[0]?.fk_company,
            fk_purchase_branch: formData[0]?.fk_branch,
            fk_department: formData[0]?.fk_department,
            // fk_itemmaster: formData[0]?.fk_itemmaster,
            serial_number_of_instrument: formData[0]?.serial_number_of_instrument,
            starting_date_of_amc: formData[0]?.starting_date_of_amc,
            ending_date_of_amc: formData[0]?.ending_date_of_amc,
            duration_of_amc: formData[0]?.duration_of_amc,
            amc_status: status
        }
        if(['SU'].includes(getCurrentRole())){
            payloadData={
                ...payloadData,
                change_log_remark: formData[0]?.change_log_remark,
                amc_status: formData[0]?.amc_status,
            }
        }
        let res
        if (isCustomPopup) {
            for (let obj in payloadData) {
                const field = section.fields.filter((field, index) => {
                    if (field.name === obj) {
                        return true;
                    }
                    return false;
                });
                if (field.length > 0 && field[0]?.required && (payloadData[obj] === undefined || payloadData[obj] === "")) {
                    let errLabel = field.length ? field[0].label : obj;
                    toast.error(errLabel + " is Required", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    return
                }
            }
        }
        if (formData[0]?.amc_id) {
            let AMCUpddateApiById = AMCUpdateApi(formData[0].amc_id)
            res = await putDataFromApi(AMCUpddateApiById, payloadData)

        } else {
            res = await postDataFromApi(AMCCreateApi, payloadData);
        }
        if (res?.data?.status === 200) {
            if (isFromSubForm) {
                callback(res.data.data.amc_id)
                return
            }

            toast.success(res?.data?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            if (isCustomPopup) {
                setFormData((prev) => {
                    return {
                        ...prev,
                        [0]: {
                            ...prev[0],
                            ['amc_id']: res.data.data.amc_id
                        }
                    }
                })
                setIsCustomPopup(false)
            }
            else {
                navigate("/AMCList")
            }

        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            if (isFromSubForm) {
                callback('')
                return
            }
        }
    }
    catch (ex) {
        console.log('---', ex)
    }
    finally {
        setIsOverlayLoader(false)
    }
}

export const handleAMCDelete = async (
    EditRecordId,
    setIsDelete,
    getAllListingData,
    setPopupIndex

) => {
    try {
        let AMCDeleteApiById = AMCDeleteApi(EditRecordId)
        let res = await deleteDataFromApi(AMCDeleteApiById);
        if (res?.data?.status === 200) {
            toast.success(res.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            getAllListingData();
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    catch (ex) { }
    finally {
        setIsDelete(false);
        setPopupIndex(-1);
    }


}